






















import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import i18n from "@/Plugin/i18n.ts";
import { Route } from "vue-router";
import RecordHistory from "@/models/history/recordHistory.model";

@Component
export default class BaseHistory extends BaseVue {
  created() {}

  get hasParent() {
    return !!this.$route.params.parentId;
  }

  get history() {
    return this.$store.state.recordHistory;
  }

  gotTo(tab: RecordHistory) {
    let indexOfLastTab = this.history.findIndex(x => x.id == tab.id);
    let elements = this.$store.state.recordHistory.slice(0, indexOfLastTab);
    this.$store.state.recordHistory = elements;
    this.$router.push(tab.url);
  }
}
